/**
 * Score of a single LLM answer, the same rule as the backend
 * (scoring.analysis_score): the position is normalised first, then
 * 1 -> 100, 2 -> 80, 3 -> 60, 4+ -> 30, otherwise 0.
 */

/**
 * Position from a stored analysis as a whole number. Whole numbers, whole
 * floats (1.0) and strings holding a whole number ("4", " 2 ") count;
 * anything else (text, 4.5, booleans, null) is null, i.e. "mentioned without
 * a valid position".
 */
export const normalizePosition = (position: unknown): number | null => {
  if (typeof position === 'boolean') return null;
  let value: unknown = position;
  if (typeof position === 'string') {
    const trimmed = position.trim();
    value = trimmed === '' ? NaN : Number(trimmed);
  }
  return typeof value === 'number' && Number.isInteger(value) ? value : null;
};

export const calculateMentionScore = (mentioned: unknown, position: unknown): number => {
  if (!mentioned) return 0;
  const normalized = normalizePosition(position);
  if (normalized === 1) return 100;
  if (normalized === 2) return 80;
  if (normalized === 3) return 60;
  if (normalized !== null && normalized >= 4) return 30;
  return 0;
};
